export function createAction<T>(type: string, payload?: CallableFunction) {
  return (...args: any[]) => ({
    type,
    payload: (payload ? payload(...args) : void 0) as T,
  });
}
